/*eslint-disable*/
import React from "react";

import { useMediaQuery, useTheme } from "@material-ui/core";

import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import SectionApresentation from "./Sections/SectionApresentation";
import SectionContact from "./Sections/SectionContact.js";
import SectionLocation from "./Sections/SectionLocation.js";
import SectionPartners from "./Sections/SectionPartners.js";
import SectionSkills from "./Sections/SectionSkills.js";
import "./index.css";

import Slider from "components/Slider/index";
import { APP_STRINGS } from "constants/appStrings";

import whatsappIcon from "../../assets/img/novas-imagens/whatsappIcon.png";

const revealSection = (selector) => {
  const reveals = document.querySelectorAll(selector);

  for (let i = 0; i < reveals.length; i += 1) {
    const windowHeight = window.innerHeight;
    const elementTop = reveals[i].getBoundingClientRect().top;
    const elementVisible = 130;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    }
  }
};

export default function LandingPage({ ...rest }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    const onScroll = () => {
      revealSection(".reveal-skills");
      revealSection(".reveal-partners");
    };

    onScroll();
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const rollPageOnClickButton = (nameDiv) => {
    const element = document.getElementById(nameDiv);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleNavigateWhatsapp = () => {
    window.open(APP_STRINGS.links.whatsapp, "_blank");
  };

  return (
    <div className="landing-shell">
      <Header
        color="transparent"
        brand={
          isMobile
            ? APP_STRINGS.brand.mobile
            : APP_STRINGS.brand.desktop
        }
        links={
          <HeaderLinks
            dropdownHoverColor="info"
            rollPageOnClickButton={rollPageOnClickButton}
          />
        }
        rollPageOnClickButton={rollPageOnClickButton}
        fixed
        changeColorOnScroll={{
          height: 180,
          color: "white",
        }}
        {...rest}
      />

      <div id="home">
        <Slider onPrimaryAction={() => rollPageOnClickButton("contact")} />
      </div>

      <main className="landing-main">
        <div className="landing-content">
          <section id="apresentation" className="landing-section">
            <SectionApresentation
              rollPageOnClickButton={rollPageOnClickButton}
            />
          </section>

          <section
            id="skills"
            className="landing-section reveal-skills"
          >
            <SectionSkills rollPageOnClickButton={rollPageOnClickButton} />
          </section>

          <section
            id="partners"
            className="landing-section reveal-partners"
          >
            <SectionPartners rollPageOnClickButton={rollPageOnClickButton} />
          </section>

          <section id="location" className="landing-section">
            <SectionLocation rollPageOnClickButton={rollPageOnClickButton} />
          </section>

          <section id="contact" className="landing-section">
            <SectionContact />
          </section>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer__inner">
          <div className="landing-footer__brand">
            <span className="landing-footer__eyebrow">
              {APP_STRINGS.footer.eyebrow}
            </span>
            <strong className="landing-footer__title">
              {APP_STRINGS.footer.title}
            </strong>
            <span className="landing-footer__text">
              {APP_STRINGS.footer.text}
            </span>
          </div>

          <div className="landing-footer__meta">
            <span>
              &copy; {new Date().getFullYear()} {APP_STRINGS.footer.rights}
            </span>
            <a
              href={APP_STRINGS.links.instagram}
              target="_blank"
              rel="noreferrer"
            >
              {APP_STRINGS.footer.instagram}
            </a>
            <a
              href={APP_STRINGS.links.whatsappShort}
              target="_blank"
              rel="noreferrer"
            >
              {APP_STRINGS.footer.whatsapp}
            </a>
          </div>
        </div>
      </footer>

      <div className="floating-whatsapp">
        <button
          type="button"
          aria-label={APP_STRINGS.floatingWhatsapp.ariaLabel}
          onClick={handleNavigateWhatsapp}
        >
          <img src={whatsappIcon} alt="" />
        </button>
      </div>
    </div>
  );
}
